
import { Modal } from "react-bootstrap";
import React, { useState } from "react";

const XpressDeclineAlert = ({showConfirmPopup, handlePopUpClose, setShowConfirmPopup}) =>{
    
  const [reason, setReason] = useState("");
    return (
        <div>{showConfirmPopup ?
            <Modal show={showConfirmPopup} backdrop="static">
              <Modal.Header>
                <Modal.Title>If you wish to decline the order, please mention the reason</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="input-group input-group-sm mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="inputGroup-sizing-sm">
                      Reason/Comments
                    </span>
                  </div>
                  <input
                    type="text"
                    value={reason}
                    onChange={(e) => {
                      setReason(e.target.value);
                    }}
                    className="form-control"
                    aria-label="Small"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    handlePopUpClose({reason:reason, status:"REJECTED"});
                  }}
                >
                  Yes
                </button>

                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => setShowConfirmPopup(false)}>
                  Close
                </button>
              </Modal.Footer>

            </Modal>
            :
            null
          }</div>
    )
}

export default XpressDeclineAlert;